export default "__VITE_ASSET__DDQcgN8F__"